import { shareSurfaceWithUsersMutation } from 'graphql/user/mutations/share-surface-with-users';
import toast from 'services/toast';
import useMutation from 'hooks/use-mutation';
import useCurrentSurface from 'routes/surface/hooks/use-current-surface';
import Response from 'services/graphql/response';
import { useTranslation } from 'react-i18next';
import { surfaceHierarchyQuery } from 'graphql/surface/queries/surface-hierarchy';

interface Input {
  sharedWith: { email: string; role: string }[];
  shareSubSurfaces: boolean;
}

type UseShareSurfaceWithUsers = (input: Input) => Promise<Response<any>>;

export default function useShareSurfaceWithUsers(): UseShareSurfaceWithUsers {
  const { t } = useTranslation();

  const surface = useCurrentSurface();

  const [shareSurfaceWithUsers] = useMutation(shareSurfaceWithUsersMutation, {
    refetchQueries: [
      {
        query: surfaceHierarchyQuery,
        variables: { input: { surface: surface?.id } },
      },
    ],
  });

  return async function (params: Input): Promise<Response<any>> {
    const input = {
      ...params,
      surface: surface?.id,
    };

    const response = await shareSurfaceWithUsers({ variables: { input } });

    if (response.isFailure) {
      toast.error(response.getErrorMessage());
    } else {
      toast.success(t('Successfully sent invitations'));
    }

    return response;
  };
}
